module.exports = __webpack_public_path__ + "static/media/accept.b6e33442.svg";